export const RELEASE_NOTES_TELEMETRY_APP_ID = "ServiceDesk";

export const RELEASE_NOTES_TELEMETRY_SCENARIO = {
  SPLASH: "SplashReleaseNotes",
  FULL: "FullReleaseNotes",
  ROLLBACK: "RollBackReleaseNotes"
};

export const RELEASE_NOTES_TELEMETRY_SCENARIO_STEP = {
  SPLASH_LOADED: "SplashLoaded",
  SPLASH_CLOSED: "SplashClosed",
  OPEN_RELEASE_DETAILS_CHECKBOX: "OpenDetailCheckbox",
  OPEN_RELEASE_DETAILS_LINK: "OpenDetailLink",
  TOGGLE_SPLASH_PREVIOUS_RELEASE: "ToggleSplashPreviousRelease",
  OPEN_FULL_PREVIOUS_RELEASE: "PreviousFullReleaseNote",
  SHOW_ROLLBACK: "ShowRollback"
};
